import { Primary } from '@cinch-labs/design-system'
import { useLatestVehicles } from '@cinch-nx/landing-ui-shared'
import { VehicleCard } from '@cinch-nx/landing-ui-shared'

import { TrackingEventTypes, useAnalytics } from '@cinch-nx/shared-analytics'
import { Wrapper } from '@cinch-nx/shared-ui'

import styles from './latest-cars-section.module.css'

export interface LatestCarsSectionProps {
  tags?: string
  fuelType?: string
  seats?: string
  colour?: string
  bodyType?: string
  numberOfVehicles?: number
}

export const LatestCarsSection: React.FC<LatestCarsSectionProps> = ({
  tags,
  fuelType,
  seats,
  colour,
  bodyType,
  numberOfVehicles,
}) => {
  const { data, countOfData, browseButtonUrl, error } = useLatestVehicles({
    tags: tags as string,
    fuelType: fuelType as string,
    bodyType: bodyType as string,
    seats: seats as string,
    colour: colour as string,
    numberOfVehicles: numberOfVehicles as number,
    caller: 'seo-pages',
  })
  const { trackEvent } = useAnalytics()

  if (!data) {
    return <div>Loading...</div>
  }

  if (error) {
    console.log(error)
    return null
  }

  if (data.vehicleListings.length === 0) {
    return null
  }
  return (
    <section className={styles.wrapper}>
      <Wrapper>
        <div className={styles.cardContainer}>
          {data.vehicleListings.map((vehicle) => (
            <VehicleCard
              key={vehicle.vehicleId}
              id={vehicle.vehicleId}
              vehicle={vehicle}
              isAvailable={vehicle.isAvailable}
              isSaved={false}
              isPending={false}
              discountInPence={vehicle.discountInPence}
              showActions={false}
              onCardClick={() => {
                trackEvent({
                  eventName: `SEO pages - View fpa card click`,
                  data: {
                    event: {
                      name: 'click',
                      category: 'button',
                      label: `seo_view_fpa_card`,
                      value: vehicle,
                    },
                  },
                  type: TrackingEventTypes.ADOBE,
                })
              }}
            ></VehicleCard>
          ))}
        </div>
        <div className={styles.buttonWrapper}>
          <Primary
            element="a"
            href={browseButtonUrl}
            onClick={() => {
              trackEvent({
                eventName: `SEO pages - Browse cars click`,
                data: {
                  event: {
                    name: 'click',
                    category: 'button',
                    label: `Browse cars button on SEO pages`,
                  },
                },
                type: TrackingEventTypes.ADOBE,
              })
            }}
            classNames={{ button: styles.browseCarsButton }}
          >
            Browse {countOfData ? countOfData : 'all'} cars
          </Primary>
        </div>
      </Wrapper>
    </section>
  )
}
